module.exports = __webpack_public_path__ + "static/morales-family-5763f8c88da1de03020c4a6eeb246922.jpg";